import {tns} from 'tiny-slider/src/tiny-slider';

export function LogoSlider() {
    let slidesContainer = document.querySelectorAll('.owl-carousel');
    let sliderInstance = {};

    function initSlider() {
        slidesContainer.forEach(slider => {
            sliderInstance = tns({
                container: slider,
                items: 6,
                slideBy: 'page',
                swipeAngle: false,
                speed: 500,
                autoplay:true,
                autoplayHoverPause: true,
                autoplayTimeout: 3500,
                controls: false,
                responsive: {
                    320: {
                        items: 2,
                    },
                    767: {
                        items: 4,
                    },
                    1024: {
                        items: 6,
                    },
                },
                nav: false,
                loop: true,
                mouseDrag: true,

            });
        });
    }


    if (slidesContainer.length >= 1) {
        initSlider();
    }

}


